
import * as React from "react"
import { cn } from "@/lib/utils"
import { Typography, type TypographyProps } from "./base"

// Movie-specific typography components
export const MovieTitle = React.forwardRef<HTMLParagraphElement, Omit<TypographyProps, "as" | "size" | "weight">>(
  ({ className, variant = "default", ...props }, ref) => (
    <Typography
      ref={ref}
      as="p"
      variant={variant}
      size="body"
      weight="bold"
      className={cn("tracking-tight", className)}
      {...props}
    />
  )
)
MovieTitle.displayName = "MovieTitle"

export const MovieYear = React.forwardRef<HTMLParagraphElement, Omit<TypographyProps, "as" | "size">>(
  ({ className, variant = "muted", weight = "regular", ...props }, ref) => (
    <Typography
      ref={ref}
      as="p"
      variant={variant}
      size="small"
      weight={weight}
      className={className}
      {...props}
    />
  )
)
MovieYear.displayName = "MovieYear"

export const MovieDirector = React.forwardRef<HTMLSpanElement, Omit<TypographyProps, "as" | "size">>(
  ({ className, variant = "muted", weight = "regular", ...props }, ref) => (
    <Typography
      ref={ref}
      as="span"
      variant={variant}
      size="small"
      weight={weight}
      className={className}
      {...props}
    />
  )
)
MovieDirector.displayName = "MovieDirector"
